// extracted by mini-css-extract-plugin
module.exports = {"header":"MovieContainer_header__3VCDI","movieList":"MovieContainer_movieList__87G0o","movieContainer":"MovieContainer_movieContainer__1XLcd"};